import { render, staticRenderFns } from "./openScreenPromotionEdit.vue?vue&type=template&id=33512dfd&"
import script from "./openScreenPromotionEdit.vue?vue&type=script&lang=js&"
export * from "./openScreenPromotionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports